module.exports = __webpack_public_path__ + "static/media/an-giam-thit.cce6b0d0.jpeg";